<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Cancelar Requisição </label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col cols="12" sm="2">
          <v-btn
            color="info"
            to="/requisicao/criar"
            v-if="isAllowed(9)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="all">
              <template v-slot:label>
                <v-chip class="ma-1 text-h6" label>
                  <v-avatar color="primary" size="12">
                    <span class="white--text text-h6">TD</span>
                  </v-avatar>
                  Todas
                </v-chip>
              </template> </v-radio
            ><v-radio value="aa" @change="onFilterChange('aa')">
              <template v-slot:label>
                <v-chip class="ma-1 text-h6" label>
                  <v-avatar color="red" size="12">
                    <span class="white--text text-h6">AA</span>
                  </v-avatar>
                  Aguardando Aprovação
                </v-chip>
              </template>
            </v-radio>
            <v-radio value="pa" @change="onFilterChange('pa')">
              <template v-slot:label>
                <v-chip class="ma-1 text-h6" label>
                  <v-avatar color="red" size="12">
                    <span class="white--text text-h6">PA</span>
                  </v-avatar>
                  Pend. Almoxarifado
                </v-chip>
              </template>
            </v-radio>
            <v-radio value="gs" @change="onFilterChange('gs')">
              <template v-slot:label>
                <v-chip class="ma-1 text-h6" label>
                  <v-avatar color="yellow" size="12">
                    <span class="white--text text-h6">GS</span>
                  </v-avatar>
                  Gerada Solicitação
                </v-chip>
              </template>
            </v-radio>
            <v-radio value="ap" @change="onFilterChange('ap')">
              <template v-slot:label>
                <v-chip class="ma-1 text-h6" label>
                  <v-avatar color="yellow" size="12">
                    <span class="white--text text-h6">AP</span>
                  </v-avatar>
                  Atendida Parcial
                </v-chip>
              </template>
            </v-radio>
            <v-radio value="at" @change="onFilterChange('at')">
              <template v-slot:label>
                <v-chip class="ma-1 text-h6" label>
                  <v-avatar color="yellow" size="12">
                    <span class="white--text text-h6">AT</span>
                  </v-avatar>
                  Atendida Total
                </v-chip>
              </template>
            </v-radio>
            <v-radio value="bx" @change="onFilterChange('bx')">
              <template v-slot:label>
                <v-chip class="ma-1 text-h6" label>
                  <v-avatar color="green" size="12">
                    <span class="white--text text-h6">B</span>
                  </v-avatar>
                  Baixada
                </v-chip>
              </template>
            </v-radio>
            <v-radio value="dc" @change="onFilterChange('dc')">
              <template v-slot:label>
                <v-chip class="ma-1 text-h6" label>
                  <v-avatar color="grey darken-1" size="12">
                    <span class="white--text text-h6">D</span>
                  </v-avatar>
                  Declinada
                </v-chip>
              </template>
            </v-radio>
            <v-radio value="in" @change="onFilterChange('in')">
              <template v-slot:label>
                <v-chip class="ma-1 text-h6" label>
                  <v-avatar color="blue-grey lighten-4" size="12">
                    <span class="white--text text-h6">I</span>
                  </v-avatar>
                  Inativa
                </v-chip>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="1">
          <v-btn
            @click="baixarlista()"
            v-if="requisicoes.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <!--<template v-slot:item.autorizado="{ item }">
          {{ item.autorizado ? "Sim" : "Não" }}
        </template>-->
        <template v-slot:item.prioridade="{ item }">
          {{ item.prioridade == 1 ? "Normal" : "Emergencial" }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-avatar v-if="(item.status = 2)" color="red" size="24">
            <span class="white--text text-h5">AA</span>
          </v-avatar>
          <v-avatar v-else-if="(item.status = 3)" color="red" size="24">
            <span class="white--text text-h5">PA</span>
          </v-avatar>
          <v-avatar v-else-if="(item.status = 4)" color="yellow" size="24">
            <span class="white--text text-h5">GS</span>
          </v-avatar>
          <v-avatar v-else-if="(item.status = 5)" color="yellow" size="24">
            <span class="white--text text-h5">AP</span>
          </v-avatar>
          <v-avatar v-else-if="(item.status = 6)" color="yellow" size="24">
            <span class="white--text text-h5">AT</span>
          </v-avatar>
          <v-avatar v-else-if="(item.status = 7)" color="green" size="24">
            <span class="white--text text-h5">B</span>
          </v-avatar>
          <v-avatar
            v-else-if="(item.status = 8)"
            color="grey darken-1"
            size="24"
          >
            <span class="white--text text-h5">D</span>
          </v-avatar>
          <v-avatar v-else color="blue-grey lighten-4" size="24">
            <span class="white--text text-h5">I</span>
          </v-avatar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(9)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
        <template v-slot:item.data="{ item }">
          <span>{{ new Date(item.data).toLocaleString() }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listaRequisicao",
  data() {
    return {
      selectedFilter: "all",
      loading: false,
      search: "",
      showAtivo: false,
      active_tab: 2,
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
        },
        { text: "Data Hora", value: "data" },
        { text: "Unidade", value: "unidadeAdm" },
        { text: "Local de Entrega", value: "local" },
        { text: "Prioridade", value: "prioridade" },
        { text: "Id OS", value: "idOrdemServico" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState("requisicao", ["requisicoes"]),
    /*filteredList() {
      if (this.showAtivo === false) {
        return this.requisicoes.filter((r) => {
          return r.id
            .toString()
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
            r.unidadeAdm.toLowerCase().includes(this.search.toLowerCase()) ||
            r.local.toLowerCase().includes(this.search.toLowerCase());
        });
      } else {
        return this.requisicoes.filter((r) => {
          return (
            r.id.toString().toLowerCase().includes(this.search.toLowerCase()) ||
            r.unidadeAdm.toLowerCase().includes(this.search.toLowerCase()) ||
            r.local.toLowerCase().includes(this.search.toLowerCase()) &&
            r.autorizado === true
          );
        });
      }
    },*/
    filteredList() {
      //return this.requisicoes.map(r => r.produtos.filter(p => p.produto.toLowerCase().includes(this.search.toLowerCase())));
      var result = this.requisicoes.map((req) => {
        return {
          ...req,
          produtos: req.produtos.filter((p) =>
            p.produto.toLowerCase().includes(this.search.toLowerCase())
          ),
        };
      });
      console.log(result);
      return result;
    },
  },
  methods: {
    ...mapActions("requisicao", [
      "atualizarRequisicoes",
      "atualizarRequisicao",
    ]),
    editar(requisicao) {
      this.atualizarRequisicao(requisicao);
      if (this.isAllowed(12)) {
        this.$router.push(`/requisicao/editar`);
      } else {
        this.$router.push(`/requisicao/ver`);
      }
    },
    baixarlista() {
      //downloadLista();
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarRequisicoes();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    onFilterChange(selectedFilter) {},
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
};
</script>
